import { LocalShipping, SwapCalls, CheckCircle } from '@material-ui/icons'

import { strings } from '@constants'

import {
	TrackerWrapper,
	CircleRow,
	Track,
	Fill,
	Circle,
	LabelRow,
	StepMeta,
	StepLabel,
	StepDate,
	TransitCircle,
	TransitTooltip,
	TransitLabel,
	TransitCoveredLabel,
	TooltipRow,
} from './style'
const DistanceProgress = ({
	completedIndex,
	fillPercent,
	showTransit,
	transitPercent,
	transitDone,
	displayTotal,
	displayCovered,
	displayRemaining,
	loadedDate,
	inTransitDate,
	deliveredDate,
}) => (
	<TrackerWrapper>
		<CircleRow>
			<Track />
			<Fill $percent={fillPercent} />
			<Circle done={completedIndex >= 1}>
				<LocalShipping fontSize='small' />
			</Circle>
			{showTransit && (
				<TransitCircle $percent={transitPercent} done={transitDone}>
					<SwapCalls fontSize='small' />
					{displayCovered > 0 && (
						<TransitCoveredLabel>
							<b>Distance Traveled:</b> {displayCovered} km
						</TransitCoveredLabel>
					)}
					{inTransitDate && completedIndex < 3 && (
						<TransitTooltip $position='bottom'>
							<TooltipRow>
								<b>EN ROUTE:</b> {inTransitDate}
							</TooltipRow>
							<TooltipRow>
								<b>Covered:</b> {Math.round(transitPercent)}%
							</TooltipRow>
						</TransitTooltip>
					)}
				</TransitCircle>
			)}
			<Circle done={completedIndex >= 3}>
				<CheckCircle fontSize='small' />
			</Circle>
		</CircleRow>
		<LabelRow>
			<StepMeta $position='start'>
				<StepLabel>{strings('loaded')}</StepLabel>
				<StepDate>{loadedDate}</StepDate>
			</StepMeta>
			{/* {showTransit && (
				<TransitLabel $percent={transitPercent}>
					<StepLabel>{strings('intransit')}</StepLabel>
					<StepDate>{inTransitDate}</StepDate>
					<StepDate>
						<b>Covered:</b> {Math.round(transitPercent)}%
					</StepDate>
				</TransitLabel>
			)} */}
			<StepMeta $position='end'>
				<StepLabel>{strings('delivered')}</StepLabel>
				<StepDate>{deliveredDate}</StepDate>
				{displayTotal > 0 && (
					<StepDate>
						<b>Route Distance:</b> {displayTotal} km
					</StepDate>
				)}
			</StepMeta>
		</LabelRow>
	</TrackerWrapper>
)

export default DistanceProgress
